class GtrStorage {
  setItem(key: string, item: any): void {
    sessionStorage.setItem(key, item)
  }

  getItem(key: string): any {
    return sessionStorage.getItem(key)
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key)
  }

  clear(): void {
    sessionStorage.clear()
  }
}

export default new GtrStorage()
